const config = {
  authRealm: process.env.uvote2,
  authUrl: process.env.https://authuvote.prod.cineca.it/auth,
  authClientId: process.env.uvote-ceo,
  credentials: {
    secret: process.env.3200KDPxSOWsO20ZpULd6AhvMVRtY0wj
  },

  logoutRedirectUri: process.env.https://uvote2.cineca.it/
};

export default config;
